import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, TransitRequestWFSteps, Languages, ServiceStatus, TugType, TugCategory } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { ConfirmVesselEntranceComponent } from '../confirm-vessel-entrance/confirm-vessel-entrance.component';
import { Router } from '@angular/router';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { EbookingRequestTugDTO, EbookingRequestTugDTOList } from 'src/app/front-user/services/e-booking/shared/models/ebooking-request-tug.model';

@Component({
  selector: 'app-impose-tug-boats',
  templateUrl: './impose-tug-boats.component.html',
})
export class ImposeTugBoatsComponent {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  imposeTugBoatsForm: FormGroup;
  tugType = TugType;
  tugCategory = TugCategory;
  tugCategoryKeys = Object.keys(this.tugCategory);
  activeTugBoatType = TugType.EscortTug;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  loading = false;
  baseRequestId: string = '';
  displayedLang: string;
  currentUser: User = new User();
  ebookingRequestTugsList: EbookingRequestTugDTOList = new EbookingRequestTugDTOList();
  isLoaded: boolean = false;
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  @ViewChild('ImposeTugBoats', { static: false }) imposeTugBoatsEle: ElementRef;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  stepData: any;
  deletedTugs: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
  ) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "bd9241b1-859d-4dec-addb-7ede244548c9";
      this.GetImposedTugBoats();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
    this.tugCategoryKeys = this.tugCategoryKeys.slice(this.tugCategoryKeys.length / 2);
  }

  ngOnInit() {
    this.buildForm();
  }


  buildForm() {
    this.imposeTugBoatsForm = this.formBuilder.group({
      escortTugs: this.formBuilder.array([]),
      imposedTugs: this.formBuilder.array([])
    });
  }

  get f() { return this.imposeTugBoatsForm.controls; }

  // Method to switch between tabs
  switchTugBoatType(type) {
    this.activeTugBoatType = type;
  }

  // Add escort tug rule
  addEscortTugRule() {
    const escortTugsArray = this.imposeTugBoatsForm.get('escortTugs') as FormArray;
    escortTugsArray.push(this.createTugGroup(this.tugType.EscortTug));
    escortTugsArray.at(escortTugsArray.length - 1).get('ImposedBy')?.setValue(this.currentUser.UserName);
    escortTugsArray.at(escortTugsArray.length - 1).get('IsApproved')?.setValue(true);
    escortTugsArray.at(escortTugsArray.length - 1).get('ApprovedBy')?.setValue(this.currentUser.UserName);
  }

  // Add imposed tug rule
  addImposedTugRule() {
    const imposedTugsArray = this.imposeTugBoatsForm.get('imposedTugs') as FormArray;
    imposedTugsArray.push(this.createTugGroup(this.tugType.ImposedTug));
    imposedTugsArray.at(imposedTugsArray.length - 1).get('ImposedBy')?.setValue(this.currentUser.UserName);
    imposedTugsArray.at(imposedTugsArray.length - 1).get('IsApproved')?.setValue(true);
    imposedTugsArray.at(imposedTugsArray.length - 1).get('ApprovedBy')?.setValue(this.currentUser.UserName);
  }

  // Create tug form group
  createTugGroup(tugType: number): FormGroup {
    const baseControls = {
      TugsNo: ['', Validators.required],
      Reason: [''],
      Note: [''],
      ImposedBy: [''],
      ApprovedBy: [''],
      IsApproved: [null],
      RejectionReason: [''],
      TugType: [tugType],
      ServiceId: [17] // Default ServiceId for Marine imposed tugs
    };

    if (tugType === this.tugType.ImposedTug) {
      return this.formBuilder.group({
        ...baseControls,
        TugCategory: [null, [Validators.required]]
      });
    }
    return this.formBuilder.group(baseControls);
  }

  // Delete escort tug rule
  deleteEscortTugRule(index: number) {
    const escortTugsArray = this.imposeTugBoatsForm.get('escortTugs') as FormArray;
    const tugGroup = escortTugsArray.at(index);
    if (tugGroup) {
      tugGroup.get('IsDeleted')?.setValue(true);
      const tugId = tugGroup.get('Id')?.value;
      if (tugId != null && tugId != undefined) {
        this.deletedTugs.push(tugGroup.getRawValue());
      }
      escortTugsArray.removeAt(index);
    }
  }

  // Delete imposed tug rule
  deleteImposedTugRule(index: number) {
    const imposedTugsArray = this.imposeTugBoatsForm.get('imposedTugs') as FormArray;
    const tugGroup = imposedTugsArray.at(index);
    if (tugGroup) {
      tugGroup.get('IsDeleted')?.setValue(true);
      const tugId = tugGroup.get('Id')?.value;
      if (tugId != null && tugId != undefined) {
        this.deletedTugs.push(tugGroup.getRawValue());
      }
      imposedTugsArray.removeAt(index);
    }
  }

  GetImposedTugBoats() {
    this.transitService.GetImposedTugBoats(this.baseRequestId).subscribe(
      d => {
        this.isLoaded = true;
        this.patchTugBoatsData(d.Data);
      }
    )
  }

  patchTugBoatsData(data) {
    const escortTugsArray = this.imposeTugBoatsForm.get('escortTugs') as FormArray;
    const imposedTugsArray = this.imposeTugBoatsForm.get('imposedTugs') as FormArray;

    // Clear existing form arrays
    escortTugsArray.clear();
    imposedTugsArray.clear();

    // Separate data by TugType and patch to respective arrays
    data.forEach(item => {
      if (item.TugType === TugType.EscortTug) {
        // Add to escortTugs array — all loaded tugs require an approve/reject decision
        const tugGroup = this.createTugGroup(TugType.EscortTug);
        tugGroup.get('IsApproved')?.setValidators(Validators.required);
        tugGroup.get('IsApproved')?.updateValueAndValidity();
        tugGroup.patchValue({
          TugsNo: item.TugsNo,
          Reason: item.Reason,
          Note: item.ServiceId === 13 ? item.MeasurmentNote : item.MarineNote,
          TugType: item.TugType,
          ImposedBy: item.AssignedBy,
          ApprovedBy: item.ApprovedBy,
          IsApproved: item.IsApproved,
          RejectionReason: item.RejectionReason,
          ServiceId: item.ServiceId
        });
        if (item.ServiceId === 13) {
          tugGroup.get('TugsNo')?.disable();
          tugGroup.get('Reason')?.disable();
          tugGroup.get('Note')?.disable();
        }
        tugGroup.addControl('Id', this.formBuilder.control(item.Id));
        tugGroup.addControl('IsDeleted', this.formBuilder.control(item.IsDeleted || false));
        escortTugsArray.push(tugGroup);
      } else if (item.TugType === TugType.ImposedTug) {
        // Add to imposedTugs array — all loaded tugs require an approve/reject decision
        const tugGroup = this.createTugGroup(TugType.ImposedTug);
        tugGroup.get('IsApproved')?.setValidators(Validators.required);
        tugGroup.get('IsApproved')?.updateValueAndValidity();
        tugGroup.patchValue({
          TugsNo: item.TugsNo,
          Reason: item.Reason,
          Note: item.MarineNote,
          TugType: item.TugType,
          TugCategory: item.TugCategory,
          ImposedBy: item.AssignedBy,
          ApprovedBy: item.ApprovedBy,
          IsApproved: item.IsApproved,
          RejectionReason: item.RejectionReason,
          ServiceId: item.ServiceId
        });
        tugGroup.addControl('Id', this.formBuilder.control(item.Id));
        tugGroup.addControl('IsDeleted', this.formBuilder.control(item.IsDeleted || false));
        imposedTugsArray.push(tugGroup);
      }
    });
  }

  private hasNewTugsAdded(escortTugsArray: FormArray, imposedTugsArray: FormArray): boolean {
    const isNewTug = (tugGroup) => {
      const idControl = tugGroup.get('Id');
      return !idControl || idControl.value == null || idControl.value === '';
    };

    return escortTugsArray.controls.some(isNewTug) || imposedTugsArray.controls.some(isNewTug);
  }

  shouldShowSubmitButton(): boolean {
    const escortTugsArray = this.imposeTugBoatsForm.get('escortTugs') as FormArray;
    const imposedTugsArray = this.imposeTugBoatsForm.get('imposedTugs') as FormArray;
    const hasNewTugsAdded = this.hasNewTugsAdded(escortTugsArray, imposedTugsArray);
    const hasDeletedTugs = this.deletedTugs.length > 0;

    // Show submit only when form is valid and there is something actionable to submit.
    return this.imposeTugBoatsForm.valid && (hasNewTugsAdded || hasDeletedTugs || this.imposeTugBoatsForm.dirty);
  }

  hasAnyEscortTugRejected(): boolean {
    const controls = (this.imposeTugBoatsForm.get('escortTugs') as FormArray)?.controls || [];
    return controls.some(tug => tug.get('IsApproved')?.value === false);
  }

  hasAnyImposedTugRejected(): boolean {
    const controls = (this.imposeTugBoatsForm.get('imposedTugs') as FormArray)?.controls || [];
    return controls.some(tug => tug.get('IsApproved')?.value === false);
  }

  OnApprovalDecisionChange(event, index: number, arrayName: 'escortTugs' | 'imposedTugs' = 'escortTugs') {
    const tugsArray = this.imposeTugBoatsForm.get(arrayName) as FormArray;
    const tugGroup = tugsArray.at(index);
    if (tugGroup) {
      tugGroup.get('ApprovedBy')?.setValue(this.currentUser.UserName);
      const rejectionReasonControl = tugGroup.get('RejectionReason');
      if (tugGroup.get('IsApproved')?.value === true) {
        tugGroup.get('RejectionReason')?.setValue('');
        rejectionReasonControl?.clearValidators();
      } else {
        rejectionReasonControl?.setValidators(Validators.required);
      }
      rejectionReasonControl?.updateValueAndValidity();
    }
  }

  focusFirstInvalidControl(): void {
    setTimeout(() => {
      if (this.f.escortTugs.invalid) {
        this.activeTugBoatType = this.tugType.EscortTug;
      } else if (this.f.imposedTugs.invalid) {
        this.activeTugBoatType = this.tugType.ImposedTug;
      }

      setTimeout(() => {
        const el = document.querySelector('form .ng-invalid') as HTMLElement;
        el?.focus();
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  private mapEscortTug(tug: any): EbookingRequestTugDTO {
    return {
      Id: tug.Id || null,
      TugType: tug.TugType,
      TugsNo: tug.TugsNo,
      Reason: tug.Reason,
      MeasurmentNote: tug.ServiceId === 13 ? tug.Note : null,
      MarineNote: tug.ServiceId === 17 ? tug.Note : null,
      RequestId: this.baseRequestId,
      ApprovedBy: tug.ApprovedBy,
      IsApproved: tug.IsApproved,
      RejectionReason: tug.IsApproved === false ? tug.RejectionReason : null,
      ServiceId: tug.ServiceId,
      AssignedBy: tug.ImposedBy,
      IsDeleted: tug.IsDeleted
    };
  }

  private mapImposedTug(tug: any): EbookingRequestTugDTO {
    return {
      Id: tug.Id || null,
      TugType: tug.TugType,
      TugsNo: tug.TugsNo,
      Reason: tug.Reason,
      MarineNote: tug.Note,
      TugCategory: tug.TugCategory,
      RequestId: this.baseRequestId,
      ApprovedBy: tug.ApprovedBy,
      IsApproved: tug.IsApproved,
      RejectionReason: tug.IsApproved === false ? tug.RejectionReason : null,
      ServiceId: tug.ServiceId,
      AssignedBy: tug.ImposedBy,
      IsDeleted: tug.IsDeleted
    };
  }

  onSubmit() {
    this.submitted = true;
    const escortTugsArray = this.imposeTugBoatsForm.get('escortTugs') as FormArray;
    const imposedTugsArray = this.imposeTugBoatsForm.get('imposedTugs') as FormArray;
    if (this.imposeTugBoatsForm.invalid) {
      this.imposeTugBoatsForm.markAllAsTouched();
      this.focusFirstInvalidControl();
      return;
    }

    if (!this.shouldShowSubmitButton()) {
      return;
    }

    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    const escortTugs = escortTugsArray.getRawValue().map(tug => this.mapEscortTug(tug));
    const imposedTugs = imposedTugsArray.getRawValue().map(tug => this.mapImposedTug(tug));
    const deletedTugsMapped = this.deletedTugs.map(tug =>
      tug.TugType === TugType.EscortTug
        ? this.mapEscortTug(tug)
        : this.mapImposedTug(tug)
    );

    this.ebookingRequestTugsList.TugBoats = [...escortTugs, ...imposedTugs, ...deletedTugsMapped] as EbookingRequestTugDTO[];

    this.transitService.ImposeTugBoats(this.ebookingRequestTugsList)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.imposeTugBoatsForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        });
  }
}
